<tt-page *ngIf="!!setting">
    <div class="col-xs-12 sp-0">
        <tt-card class="col-xs-12 col-md-4 p-5" ttHeading="h_basics">
            <tt-select ttRememberId="w_poloadplan.businessco_no" ttLabel="businessco" [(ttModel)]="setting.businessco_no" (ttModelChange)="onChanged($event, 'businessco_no')" [ttData]="selectListCompanies" ttDataId="businessco_no" ttDataName="company_name"></tt-select>
            <tt-select ttRememberId="w_poloadplan.stockplace_id" ttLabel="stockplace" [(ttModel)]="setting.stockplace_id" (ttModelChange)="onChanged($event, 'stockplace_id')" [ttData]="selectListStockPlaces" ttDataId="stockplace_id" ttDataName="stockplace_name"></tt-select>
            <tt-date-range ttRememberId="w_poloadplan" ttLabel="date_fom_tom" [(ttStartDate)]="setting.date_fom" [(ttEndDate)]="setting.date_tom" [(ttInterval)]="setting.dateselector_index" (ttModelChange)="onDateRangeChanged()"></tt-date-range>
        </tt-card>

        <tt-card class="col-xs-12 col-md-4 p-5" ttHeading="h_functions" *ngIf="setting.show_setting === '1'">
            <tt-button-settings></tt-button-settings>
        </tt-card>
    </div>

    <tt-grid *ngIf="!!grid" class="p-5 flex-1" [(ttOptions)]="grid"></tt-grid>
</tt-page>
